import { DateTimeDisplay, Icons } from "@kalyzee/escaet-ui";
import { useRefAutoUpdate } from "@kalyzee/kast-web-sdk/web-components";
import { RTCStreamSenderParamsPreset } from "@kalyzee/kast-web-sdk/webrtc";
import { useEffect, useMemo, useRef } from "react";
import { RoomsControlCard, RoomsControlCardRef } from "../../../components/pedagogy/RoomsControlCard";
import { useMeetingConfigurator, useMultiMeetingAPI } from "../../../hooks/meeting";
import { useSettings } from "../../../hooks/settings";
import { usePedagogyContext } from "./context";
import styles from "./overview.module.css";
import { DEFAULT_MAX_BITRATES } from "../../../helpers/videos";

export const OverviewPedagogyPage = () => {
  const [settings] = useSettings();
  const settingsRef = useRefAutoUpdate(settings);
  const pedagogyCtx = usePedagogyContext();
  const pedagogyCtxRef = useRefAutoUpdate(pedagogyCtx);
  const multiMeetingAPI = useMultiMeetingAPI();
  const meetingContainersAPI = useMemo(() => multiMeetingAPI.all?.getContainers()?.map((c) => c.getAPI()) ?? [], [multiMeetingAPI]);
  const roomsControlCardRef = useRef<RoomsControlCardRef>(null);

  useMeetingConfigurator(meetingContainersAPI, {
    ovenMediaSession: {
      emission: {
        options: (mediaSession) => {
          if (mediaSession.extra?.type === "camera") {
            const maxBitrate = settingsRef.current?.debug?.maxBitrate?.pedagogy?.webcam ?? DEFAULT_MAX_BITRATES.pedagogy.webcam;

            return {
              rtc: {
                streamParams: {
                  preset: RTCStreamSenderParamsPreset.VISIO_FACE,
                  video: { rtcEncoding: { maxBitrate: maxBitrate?.video } },
                  audio: { rtcEncoding: { maxBitrate: maxBitrate?.audio } },
                },
              },
            };
          }
          if (mediaSession.extra?.type === "screen") {
            const maxBitrate = settingsRef.current?.debug?.maxBitrate?.pedagogy?.screensharing ?? DEFAULT_MAX_BITRATES.pedagogy.screensharing;
            return {
              rtc: {
                streamParams: {
                  preset: RTCStreamSenderParamsPreset.VISIO_SCREENSHARING,
                  video: { rtcEncoding: { maxBitrate: maxBitrate?.video } },
                  audio: { rtcEncoding: { maxBitrate: maxBitrate?.audio } },
                },
              },
            };
          }
          return undefined;
        },
      },
      reception: {
        options: () => ({
          audio: false,
          video: { mode: "subscription", delayToDisableStream: 5000 },
        }),
      },
    },
  });


  // ---------------------------------------------------------------------- //
  // ---------------------------   UTILS ----------------------------- //
  // ---------------------------------------------------------------------- //

  // ---------------------------------------------------------------------- //
  // ---------------------------   EFFECT ----------------------------- //
  // ---------------------------------------------------------------------- //

  useEffect(() => {
    const validator = pedagogyCtxRef.current?.addAudioValidator(() => false);
    return () => {
      validator?.flush();
    };
  }, []);

  // ---------------------------------------------------------------------- //
  // ---------------------------   RENDER ----------------------------- //
  // ---------------------------------------------------------------------- //

  return (
    <div className={styles.container}>
      <div className={styles.leftPanel}>
        <img src={Icons.PedagoLogoSamii} alt="logo" />
        <DateTimeDisplay />
      </div>
      <RoomsControlCard ref={roomsControlCardRef} className={styles.content} kind="preview" />
    </div>
  );
};
